import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AbstractAppConfigService,
  APP_CONFIG_SERVICE,
  IHttpBasicResponse,
  JsonApiResponse,
} from '@boxx/core';
import { IReviewsApi } from '@boxx/messages-core';
import {
  IPanelAnalyticsPayload,
  IPanelAnalyticsResponse,
  IPanelApiResponse,
  IPanelRepository,
} from './IPanel.repository';
import * as moment from 'moment';
import { IEcwidDataStatistics } from '@boxx/gmb-core/lib/contracts/IEcwidData';

@Injectable()
export class PanelRepository implements IPanelRepository {
  constructor(
    @Inject(APP_CONFIG_SERVICE) private appSettings: AbstractAppConfigService,
    private httpClient: HttpClient
  ) {}

  getPanelData(): Observable<IHttpBasicResponse<IPanelApiResponse>> {
    return this.httpClient.get<IHttpBasicResponse<IPanelApiResponse>>(
      `${this.getBaseUrl()}/home`
    );
  }

  // getPanelAnalytics(
  //   filter?: IPanelAnalyticsPayload
  // ): Observable<JsonApiResponse<IPanelAnalyticsResponse>> {
  //   let body: URLSearchParams;
  //   if (filter) {
  //     body = this.buildUrlSearchParams(filter);
  //   }

  //   return this.httpClient.get<IHttpBasicResponse<any>>(
  //     `${this.appSettings.baseUrl()}/api/json/v1/analytics/get_accumulated_visits_summary` +
  //       (body ? `?${body}` : '')
  //   );
  // }

  getPanelAnalytics(
    filter?: IPanelAnalyticsPayload
  ): Observable<JsonApiResponse<any>> {
    let body: URLSearchParams;
    if (filter) {
      body = this.buildUrlSearchParams(filter);
    }

    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.appSettings.baseUrl()}/api/json/v2/analytics/visits`);
  }

  getPanelContacts(): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/contacts`
    );
  }

  getPanelEvents(): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/schedule`
    );
  }

  getPanelLeads(): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/leads`
    );
  }

  getPanelReviews(): Observable<IHttpBasicResponse<IReviewsApi>> {
    return this.httpClient.get<IHttpBasicResponse<IReviewsApi>>(
      `${this.getBaseUrl()}/gmb/reviews`
    );
  }

  getEcwidStadistics() {
    const currentDate = moment().add(1, 'days').format("YYYY-MM-DD");
    const initialDate = moment().subtract(30, 'days').format("YYYY-MM-DD");
    return this.httpClient.get<JsonApiResponse<IEcwidDataStatistics>>(
      `${this.getJsonBaseUrl()}/ecwid/analytics?start_date=${initialDate}&end_date=${currentDate}`
    );
  }

  refreshEcwidStadistics(startDate: string, enDate: string) {
    return this.httpClient.get<JsonApiResponse<IEcwidDataStatistics>>(
      `${this.getJsonBaseUrl()}/ecwid/analytics?start_date=${startDate}&end_date=${enDate}`
    );
  }

  private getBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/${this.appSettings.instance()}/v1`;
  }

  private getJsonBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/json/v1`;
  }

  activateNFC(payload: any): Observable<JsonApiResponse<any>> {
    const urlSearchParams = new URLSearchParams();

    Object.keys(payload).forEach((key: string) => {
      urlSearchParams.append(key, payload[key]);
    });

    const body = urlSearchParams.toString();

    return this.httpClient.post<JsonApiResponse<any>>(
      `${this.appSettings.baseUrl()}/api/json/v1/NFCDevices/activate`,
      body
    );
  }

  getNFCDevices(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.appSettings.baseUrl()}/api/json/v1/NFCDevices/list`,
    );
  }

  private buildHttpParams(payload: any) {
    let params = new HttpParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        typeof payload[key] === 'object'
          ? (params = params.append(key, JSON.stringify(payload[key])))
          : (params = params.append(key, escape(payload[key])));
      }
    }
    return params;
  }

  private buildUrlSearchParams(payload: any) {
    const params = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        typeof payload[key] === 'object'
          ? params.set(key, JSON.stringify(payload[key]))
          : params.set(key, payload[key]);
      }
    }
    return params;
  }
}
